module.exports = __webpack_public_path__ + "static/media/close-filled-red.e4e5df0c.svg";